















































import {
  Vue,
  Component,
  Prop,
  Watch,
  Mixins,
  Ref,
} from "vue-property-decorator";
import { currentCompanyStore, currentScoutingStore } from "@/store/typed";
import VAccordion from "@/components/VAccordion.vue";
import ModelParserMixin from "@/mixins/ModelParser";
import CompanyPlaceItem from "@/components/CompanyPlace/Item.vue";
import PoiModal from "@/components/CompanyPlace/PoiModal.vue";
import CompanyPlace from "@/models/CompanyPlace";
import StoreSubscriber from "@/utils/StoreSubscriber";

@Component({
  components: {
    VAccordion,
    CompanyPlaceItem,
    PoiModal,
  },
})
export default class CompanyPlaceCollapsableList extends Mixins(
  ModelParserMixin
) {
  @Prop({ default: true }) readonly deletable!: boolean;
  @Prop({ default: false }) readonly searchable!: boolean;
  @Prop({ default: false }) readonly showLegend!: boolean;

  @Ref() poiModal!: PoiModal;
  private poiSelected: CompanyPlace | undefined = new CompanyPlace();
  private term = "";
  private functionOpenModal = new Function();

  mounted() {
    this.subscribe();
  }

  destroyed() {
    this.functionOpenModal();
  }

  subscribe() {
    this.functionOpenModal = StoreSubscriber.subscribe(
      "currentCompany/$openModalPoiDetails",
      this.openModalPoiDetails.bind(this)
    );
  }

  async load() {
    await currentCompanyStore.loadCompanyPlaces(this.$route.params.id);
  }

  get isOpened() {
    return this.$route.name === "company-poi";
  }

  get companyPlaces() {
    if (this.searchable) {
      return currentCompanyStore.companyPlaces.filter(
        (o) =>
          o.name.toLowerCase().includes(this.term.toLowerCase()) ||
          o.fullAddress.toLowerCase().includes(this.term.toLowerCase())
      );
    } else {
      return currentCompanyStore.companyPlaces.sort((a, b) => {
        if (a.source === "google_places" && a.sourceId === null) {
          return -1;
        } else if (b.source === "google_places" && b.sourceId === null) {
          return 1;
        } else {
          return 0;
        }
      });
    }
  }

  get poiCount() {
    return currentCompanyStore.companyPlaces.length;
  }

  get hasIncompleted() {
    return !!currentCompanyStore.companyPlaces.find(
      (c) => c.source === "google_places" && c.sourceId == null
    );
  }

  openModalPoiDetails(companyPlace: CompanyPlace) {
    this.onPoiSelected(companyPlace.id);
  }

  onPoiSelected(companyPlaceId: string) {
    this.poiSelected = currentCompanyStore.companyPlaces.find(
      (o) => o.id === companyPlaceId
    );
    if (this.poiSelected) {
      this.poiModal.show();
    }
  }

  onSavePoi(companyPlace: CompanyPlace) {
    currentCompanyStore.saveCompanyPlace(companyPlace);
  }

  onDeletePoi(companyPlace: CompanyPlace) {
    currentCompanyStore.destroyCompanyPlace(companyPlace.id);
  }
}
